<template>

  <div id="wrapperContactForm" class="default_layout m-4">

    <div class="grid lg:grid-cols-2 grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="firstName"
        name="firstName"
        label="First Name"
        rules="required"
        @inputChanged="onInputChange"
      />
      <InputGroup
        ref="lastName"
        name="lastName"
        label="Last Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="company"
        name="company"
        label="Company Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid lg:grid-cols-2 grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="email"
        name="email"
        label="Email"
        rules="required|email"
        @inputChanged="onInputChange"
      />
      <InputPhone
        ref="phone"
        name="phone"
        label="Phone"
        rules="required|phone"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputTextArea
        ref="commentCapture"
        name="Form_Comments__c"
        label="Comments"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <button
        :class="buttonStyle"
        @click="handleSubmitClick"
      >
        Submit Form
      </button>
    </div>

  </div>
</template>

<script>
import InputGroup from '@src/components/input-group.vue';
import InputPhone from '@src/components/input-phone.vue';
import InputTextArea from '@src/components/input-textarea.vue';

export default {
  name: 'ContactLayoutDefault',
  props: {
    onInputChange: { type: Function, required: true },
    onSubmit: { type: Function, required: true },
    onError: { type: Function, required: true },
    buttonStyle: { type: String, required: false, default: 'btn_submit clientpay' },
  },
  components: {
    InputGroup,
    InputPhone,
    InputTextArea,
  },
  methods: {
    handleSubmitClick(event) {
      this.$props.onSubmit(event, this.$refs);
    },
  },
};
</script>
